import React from "react";
import { styled } from "@acko-tech/building-blocks.ui.common";
import Icon from "@widgets/Icon";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible, getWidgetSpecificProps, formatDateFromISO, formatTimeSlot } from "@utils/index";
import { useEffect } from "react";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
    ...getWidgetSpecificProps(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

export const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 94vh;
  margin-top: -44px;
  @media (min-width: 769px) {
    height: 424px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Text = styled.p`
  font-family: Euclid Circular B;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.10000000149011612px;
  text-align: center;
  color:rgb(0, 0, 0);
  margin: 0;
`;

export const DateTimeText = styled.p`
  font-family: Euclid Circular B;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #555A68;
  margin: 8px 0 0 0;
`;

const AppointmentConfirmedLoader = (props: any) => {
  const { is_visible, text, selected_date, selected_slot, actions } = props;
  
  if (!is_visible) return <></>;

  useEffect(() => {
    actions?.on_load?.forEach((func: any) => {
      func?.funCall?.();
    });
  }, []);

  const formattedDate = formatDateFromISO(selected_date || "");
  const formattedTime = formatTimeSlot(selected_slot || "");
  const dateTimeText = formattedDate && formattedTime 
    ? `${formattedDate}, ${formattedTime}`
    : "";

  return (
    <Container>
      <Icon
        overrideIsVisible={true}
        path={"/images/gif/success-tick.gif"}
        styles={{ width: "200px" }}
      />
      <Text>{text}</Text>
      {dateTimeText && <DateTimeText>{dateTimeText}</DateTimeText>}
    </Container>
  );
};

export default connect(mapStateToProps)(AppointmentConfirmedLoader);
